import React, { Component , Fragment } from "react";
import Fondo from '../assets/images/fondo.png';
import RegisterForm from '../components/molecules/RegisterForm';


class Register extends Component {
    render() {
        return (
            <Fragment> 
                <div className="main-wrap">
                    <div className="nav-header bg-transparent shadow-none border-0">
                        <div className="nav-top w-100">
                            <a href="/"> </a>
                            <button className="nav-menu me-0 ms-auto"></button>
                            <a href="/login" className="header-btn d-none d-lg-block bg-dark fw-500 text-white font-xsss p-3 ms-auto w100 text-center lh-20 rounded-xl">Login</a>
                            <a href="/register" className="header-btn d-none d-lg-block bg-current fw-500 text-white font-xsss p-3 ms-2 w100 text-center lh-20 rounded-xl">Registrate</a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-5 d-none d-xl-block p-0 vh-100 bg-image-cover bg-no-repeat"
                        style={{backgroundImage: `url(${Fondo})`, backgroundPosition: 'center'}}></div>
                        <div className="col-xl-7 vh-100 align-items-center d-flex bg-white rounded-3 overflow-hidden">
                            <div className="card shadow-none border-0 ms-auto me-auto login-card">
                                <div className="card-body rounded-0 text-left">
                                    <h2 className="fw-700 display1-size display2-md-size mb-4">Crea <br />tu cuenta</h2>  
                                    <RegisterForm />                                                                           
                                </div>
                            </div> 
                        </div>                 
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Register;